import './ActionButton.scss';
import React, { ReactElement, useState } from 'react';
import { MdMoreVert } from 'react-icons/md';
import { IBaseAction } from '@models/actions/IBaseAction';
import { IActionService } from '@services/actions/IActionService';
import { IDocBasedService } from '@services/actions/IDocBasedService';
import { IListElement } from '@/types';
import Button from '@atoms/Button';
import Menu from '@atoms/Menu';
import Preloader from '@atoms/Preloader';
import { useLocation, useNavigate } from 'react-router';
import { convertActions } from '@utils/actionsHelpers';

export interface IActionButtonProps {
    objId: string;
    objData?: any;
    service?: IActionService<IBaseAction>;
    onActionClick?: () => void;
    onModifyData?: () => void;
}

const ActionButton: React.FC<IActionButtonProps> = (props: IActionButtonProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const onActionClick = (act: IBaseAction) => {
        let executor = props.service?.getActionExecutor(act);
        if (executor) {
            executor.navigate = navigate;
            executor.location = location;
        }

        let docsBasedService = props.service as unknown as IDocBasedService;
        let parentId: string | undefined = undefined;
        if (docsBasedService) {
            parentId = docsBasedService.documentId;
        }

        executor?.run(
            props.objId,
            parentId,
            act,
            props.objData,
            (isSucceed) => {
                setElement(undefined);

                if (isSucceed && props.onModifyData) {
                    props.onModifyData();
                }
            },
            () => {
                props.onActionClick && props.onActionClick();
                //setElement(undefined);
                setElement(executor?.visualElement && executor?.visualElement());
            },
        );
        setElement(executor?.visualElement && executor?.visualElement());
    };

    const [loadingIndicators, setLoadingIndicators] = useState<{ [id: string]: boolean }>({});
    const [actItems, setActItems] = useState<IListElement[] | undefined>(
        convertActions(props.objData?.actions, onActionClick),
    );
    const [element, setElement] = useState<ReactElement>();

    return (
        <>
            {!props?.objData?.hideActions && (
                <Menu list={actItems} className="action-button__content" position="bottom-end">
                    <div className="action-button">
                        {loadingIndicators[props.objId] ? (
                            <Preloader size="s" position="inline" />
                        ) : (
                            <Button
                                buttonType="text"
                                textColor="neutral"
                                size="xxxs"
                                aria-label="Действия"
                                startAdornment={<MdMoreVert size="20" />}
                                onClick={(e) => {
                                    if (!actItems && !loadingIndicators[props.objId]) {
                                        let newLoadingIndicators = { ...loadingIndicators };
                                        newLoadingIndicators[props.objId] = true;
                                        setLoadingIndicators(newLoadingIndicators);

                                        props.service
                                            ?.fetchActions(props.objId)
                                            .then((res) => {
                                                let acts = convertActions(res.data, onActionClick);
                                                setActItems(acts);
                                            })
                                            .finally(() => {
                                                let newLoadingIndicators = { ...loadingIndicators };
                                                newLoadingIndicators[props.objId] = false;
                                                setLoadingIndicators(newLoadingIndicators);
                                            });
                                    }
                                }}
                            />
                        )}
                    </div>
                </Menu>
            )}

            {element}
        </>
    );
};

export default ActionButton;
